module.exports = __webpack_public_path__ + "static/img/2.0062a6b4.webp";